import { Inject, Injectable, InjectionToken } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PhonePrefix } from '../models/phone-prefix.model';
import { SharedApiService } from './interfaces/shared-api.service';

/**
 * Used in app.module.ts to load dictionary when app is initialized
 *
 * @param provider PhonePrefixesService service
 */
export function phonePrefixesProviderFactory(provider: PhonePrefixesService): () => Promise<boolean> {
  return () => provider.load();
}

export const REQUEST_URI = new InjectionToken<string>('phone-prefixes.path');

@Injectable({
  providedIn: 'root'
})
export class PhonePrefixesService {

  private phonePrefixes = new BehaviorSubject<PhonePrefix[]>([]);

  constructor(
    @Inject(REQUEST_URI) private uri: string,
    private api: SharedApiService
  ) {
  }

  /** Used by factory to get dictionary when app is initialized */
  load(): Promise<boolean> {
    return new Promise((resolve) => {
      resolve(true);
      this.api.getPublic<PhonePrefix[]>(this.uri)
        .subscribe(res => {
          this.phonePrefixes.next(res);
          resolve(true);
        });
    })
  }

  get prefixes(): PhonePrefix[] {
    return this.phonePrefixes.getValue();
  }
}
